module.exports = __webpack_public_path__ + "img/ring_r_s_0_1.a18d2f9d.png";